const ArrowDropDown = ({ size = 20, fill = '#FFFEFE' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2792_191690)">
            <path d="M6.79297 9.39844L11.293 5.64844L15.793 9.39844H6.79297Z" fill={fill}/>
            <path d="M6.79297 12.3984L11.293 16.1484L15.793 12.3984H6.79297Z" fill={fill}/>
        </g>
        <defs>
        <clipPath id="clip0_2792_191690">
            <rect width={size} height={size} fill={fill} transform="matrix(1 0 0 -1 0.792969 20.6484)"/>
        </clipPath>
        </defs>
    </svg>
  );
};

export default ArrowDropDown;
